import variables from 'theme/common/variables.module.sass'
import useMediaQuery from '@material-ui/core/useMediaQuery'

// returns true if breakpoint is smaller than mobileWidth
export default function IsMobile() {
  const matches = useMediaQuery(`(max-width:${variables.mobileWidth})`, { noSsr: true })
  return matches
}
